import { Title, TitleProps } from '@mantine/core';

type Props = TitleProps;

function H8(props: Props) {
  return <Title fz={16} fs="normal" fw={600} {...props} />;
}

export default H8;
